import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Navbar from "../../components/layout/Navbar";
import "../../App.css";
import { useOnlineStatus } from "../../hooks/useOnlineStatus";
import { useEnglishText } from "../../text/useEnglishText.js";
function OfflinePage() {
  const isOnline = useOnlineStatus();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useEnglishText();
  useEffect(() => {
    if (isOnline) {
      const from = location.state?.from?.pathname || "/";
      navigate(from, { replace: true });
    }
  }, [isOnline, navigate, location]);

  return (
    <div className="Error">
      <Navbar />
      <div className="DivError">
        <h1>{t("AppName")}</h1>
        <h2>No Internet Connection</h2>

        <div
          className="DivImageError"
          onClick={() => window.location.reload()}
        >
          <img
            src="/assets/images/error/errorNoin.png"
            alt="No Internet"
            className="ImageError"
            loading="lazy"
            style={{
              filter: "blur(10px)",
              transition: "filter 0.5s ease",
              objectFit: "cover",
              width: "100%",
              height: "100%",
            }}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null;
              currentTarget.src = "/assets/images/error/error500.png";
            }}
            onLoad={(e) => {
              e.target.style.filter = "blur(0px)";
            }}
          />
        </div>

        <h3>...Connecting</h3>
      </div>
    </div>
  );
}

export default OfflinePage;
